import {css} from 'lit';
export const styles = css`:host {
  --value-max-height: 110px;
  --white-space: pre-wrap;
}

div {
  max-height: var(--value-max-height);
  white-space: var(--white-space);
  overflow: auto;
}
`;
export default styles;
